<template>
  <section 
    class="insu-index-tabs mb-l"
    :style="{backgroundImage: `url(${cover})`}"
  >
    <h2 class="section-title text-center mb-m">保費試算</h2>
    <div class="index-tabs-wrapper container">
      <Tabs
        v-model="currTab"
        size="small"
      >
        <TabPane
          v-for="tab in tabContents"
          :key="tab.name"
          :name="tab.name"
          :label="tab.label"
          :disabled="tab.component === null"
          :style="paneStyle(tab.name)"
        >
          <component
            :is="tab.component"
            v-if="tab.component"
            v-bind="{handleQuery, loading}"
            :model="queryModelObj[tab.name]"
            :type="tab.name"
          />
          <img
            v-if="tab.img"
            class="index-tabs-img"
            :src="tab.img" 
            :alt="`磐石保經${tab.label}快速試算`"
          />
        </TabPane>
      </Tabs>
    </div>
  </section>
</template>

<script>
  import { Tabs, TabPane } from 'iview';
  import InsuVehicleQueryForm from '@/components/forms/InsuVehicleQueryForm';
  import InsuTravelQueryForm from '@/components/forms/InsuTravelQueryForm';
  //import InsuAccidentQueryForm from '@/components/forms/InsuAccidentQueryForm'; //20210830 Wen modify
  import InsuPetQueryForm from '@/components/forms/InsuPetQueryForm';  //20210530 Wen modify
  import InsuVaccineQueryForm from '@/components/forms/InsuVaccineQueryForm'; //20210530 Wen Add
  export default {
    components: { Tabs, TabPane },
    props: {
      loading: {
        type: Boolean,
        default: false
      },
      handleQuery: {
        type: Function,
        default: null
      },
      queryModelObj: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        currTab: 'pet',  //vaccine 20220414 4/25富邦疫苗停售 car   20210530 Wen modify 調整順序
        cover: require('@/assets/index-tab-bg.jpg'),
        tabContents: [ 
         /* {  //20220414 Wen modify 富邦疫苗停售
            label: '疫苗防疫',
            name: 'vaccine',
            component: InsuVaccineQueryForm,
            img: require('@/assets/img-vaccine-sketch.jpg'),
          },    */
          { //20210530 Wen modify
            label: '寵物險',
            name: 'pet',
            component: InsuPetQueryForm,
            img: require('@/assets/img-pet-sketch.jpg'),
          },               
          {
            label: '汽車險',
            name: 'car',
            component: InsuVehicleQueryForm,
            img: require('@/assets/img-car-sketch.jpg'),
          },          {
            label: '機車險',
            name: 'motor',
            component: InsuVehicleQueryForm,
            img: require('@/assets/img-motor-sketch.jpg'),
          },
          {//20210530 Wen modify 調整順序
            label: '旅平險',
            name: 'travel',
            component: InsuTravelQueryForm,
            img: require('@/assets/img-travel-sketch.jpg'),
          },
          /*{  //20210830 Wen modify
            label: '傷害險',
            name: 'accident',
            component: InsuAccidentQueryForm,
            img: require('@/assets/img-accident-sketch.jpg'),
          },*/
          
                    
          //,
          // {
          //   label: '年金險',
          //   name: 'annuities',
          //   component: null,
          //   model: null,
          //   img: null,
          // }
        ]
      };
    },
    methods: {
      paneStyle(name) {
        const { currTab } = this;
        return {
          opacity: currTab === name ? '1' : '0',
          visibility: currTab === name ? 'visible' : 'hidden' 
        };
      }
    }
  };
</script>
